import {
  isRejectedWithValue,
  Middleware,
  MiddlewareAPI,
  PayloadAction,
} from "@reduxjs/toolkit";

import { isDexibitApi } from "../utils/isDexibitApi";
import logger from "../utils/logger";
import { redirectToAuthorise } from "../utils/oauth";
import tokenManager from "../utils/tokenManager";
import { selectRedirectUri } from "./services/config";
import type { AppDispatch, RootState } from "./store";

interface RejectedActionMeta {
  arg?: { endpointName?: string };
  baseQueryMeta?: {
    request?: { url?: string };
  };
}

export const apiErrorHandler: Middleware =
  (api: MiddlewareAPI<AppDispatch, RootState>) =>
  (next) =>
  (action: PayloadAction<{ status: number }, string, RejectedActionMeta>) => {
    if (isRejectedWithValue(action)) {
      const status = action.payload.status;
      if (status === 401 || status === 403) {
        // checkAuthentication's 401 is the expected "not authenticated" signal
        // already handled by useInit, useAuthListener, and Navigation effects.
        // Letting middleware also act on it would race those effects and loop.
        if (action.meta.arg?.endpointName === "checkAuthentication") {
          return next(action);
        }

        const url = action.meta.baseQueryMeta?.request?.url;
        if (isDexibitApi(url)) {
          logger.warn(status === 401 ? "Unauthenticated" : "Unauthorised");
          tokenManager.removeToken();
          const redirectUri = selectRedirectUri(api.getState());
          if (redirectUri) {
            redirectToAuthorise(redirectUri);
          }
        }
      }
      logger.warn("Network error", action);
    }
    return next(action);
  };
